// @flow
import React from 'react';
import { I18n } from '@lingui/react';

import TextInput, { type Props } from '../../../formFields/TextInput';

const CreditCardNameField = (props: Props) => (
  <I18n>
    {({ i18n }) => (
      <TextInput
        sensitive
        label={i18n._('Name on Card')}
        name="cardholder-name"
        placeholder={i18n._('Name on Card')}
        autoComplete="cc-name"
        data-qa-id="credit-card-inputs-name"
        {...props}
      />
    )}
  </I18n>
);

export default CreditCardNameField;



// WEBPACK FOOTER //
// ../react-lib/src/components/forms/CreditCardForm/BraintreeCreditCardForm/CreditCardNameField.jsx